import { store } from '@src/state/store';
import {
  getCurrentGame,
  getPlayerDataFromCurrentGame,
} from '@src/state/selectors/selector_game';
import { pushEventQueue } from '@src/state/slices/slice_game';

import { Game } from '@src/lib/types';

export default () => (data: any) => {
  if (!data || !data.gameId || !data.playerId || !data.playerName) return;

  const currentGame: Game | null = getCurrentGame(store.getState());
  if (currentGame === null)
    throw new Error('[_playerDisconnected] game not found in root state');

  const playerData = getPlayerDataFromCurrentGame(
    store.getState(),
    data.playerId,
  );
  const message = playerData
    ? `${playerData.name} DISCONNECTED`
    : `${data.playerId.slice(0, 7)} DISCONNECTED`;

  if (data.gameId == currentGame.gameId) {
    console.log('PLAYER DISCONNECTED');
    store.dispatch(
      pushEventQueue({
        message,
        showToast: true,
        sound: 'error',
      }),
    );
  }
};
